import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { ModelService } from '@services/common/model.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  providers: [ModelService],
})
export class VideoModalComponent implements AfterViewInit {
  @ViewChild('tsoVideo') tsoVideo!: ElementRef;
  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit(): void {
    this.tsoVideo.nativeElement.play();
  }
}

export class NgbdModalComponent {
  constructor(private modalService: NgbModal) {}
}
